import { TreeNode } from "primereact/treenode";

export const treeForHost = [
	{
		key: "Pages",
		label: "Pages",
		data: "Pages",
		icon: "pi pi-fw pi-file",
		children: [
			{
				key: 'Pages.Dashboard',
				label: 'Dashboard',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Invoices',
				label: 'Invoices',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Invoices.CreateInvoice',
						label: 'Create Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.EditInvoice',
						label: 'Edit Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.DeleteInvoice',
						label: 'Delete Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.Sacgst',
						label: 'SAC GST',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.InvoicePayment',
						label: 'Invoice Payment',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.Industry',
						label: 'Industry',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Industry.CreateIndustry',
								label: 'Create Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.EditIndustry',
								label: 'Edit Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.DeleteIndustry',
								label: 'Delete Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Invoices.Currency',
						label: 'Currency',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Currency.CreateCurrency',
								label: 'Create Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.EditCurrency',
								label: 'Edit Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.DeleteCurrency',
								label: 'Delete Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					}

				]
			},
			{
				key: 'Pages.Client',
				label: 'Clients',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Client.AddClient',
						label: 'Add Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.EditClient',
						label: 'Edit Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.DeleteClient',
						label: 'Delete Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Items',
				label: 'Items',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Items.AddItem',
						label: 'Add Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.EditItem',
						label: 'Edit Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.DeleteItem',
						label: 'Delete Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Notifications',
				label: 'Notifications',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Notifications.createNotification',
						label: 'Create Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.updateNotification',
						label: 'Update Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.deleteNotification',
						label: 'Delete Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.PaymentSchedule',
				label: 'Payment Schedule',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Reports',
				label: 'Reports',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},

			{
				key: 'Pages.Administration',
				label: 'Administration',
				data: 'Documents Folder',
				icon: 'pi pi-fw pi-inbox',
				children: [
					{
						key: 'Pages.Administration.User',
						label: 'Users',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.User.CreateUser',
								label: 'CreateUser',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.EditUser',
								label: 'Edit User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.DeleteUser',
								label: 'Delete User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},
					{
						key: 'Pages.Administration.Templates',
						label: 'Templates',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Templates.CreateTemplate',
								label: 'Create Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Templates.EditTemplate',
								label: 'Edit Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Settings',
						label: 'Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Settings.InvoiceNumberSequence',
								label: 'Invoice Number Sequence',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Tenant',
						label: 'Tenants',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Tenant.CreateTenant',
								label: 'Create Tenant',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Tenant.EditTenant',
								label: 'Edit Tenant',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Tenant.DeleteTenant',
								label: 'Delete Tenant',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.TenantPaymentSettings',
						label: 'Tenant Payment Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.TenantPaymentSettings.CreatePaymentSettings',
								label: 'Create Payment Settings',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Role',
						label: 'Roles',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Role.CreateRole',
								label: 'Create Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.EditRole',
								label: 'Edit Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.DeleteRole',
								label: 'Delete Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},

					{
						key: 'Pages.Administration.Edition',
						label: 'Editions',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Edition.CreateEdition',
								label: 'Create Edition',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}, {
								key: 'Pages.Administration.Edition.EditEdition',
								label: 'Edit Edition',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}, {
								key: 'Pages.Administration.Edition.DeleteEdition',
								label: 'Delete Edition',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					}


				]
			}
		]
	}

]

export const treeForOthers = [
	{
		key: "Pages",
		label: "Pages",
		data: "Pages",
		icon: "pi pi-fw pi-file",
		children: [
			{
				key: 'Pages.Dashboard',
				label: 'Dashboard',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Invoices',
				label: 'Invoices',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Invoices.CreateInvoice',
						label: 'Create Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.EditInvoice',
						label: 'Edit Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.DeleteInvoice',
						label: 'Delete Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.Sacgst',
						label: 'SAC GST',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.InvoicePayment',
						label: 'Invoice Payment',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.Industry',
						label: 'Industry',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Industry.CreateIndustry',
								label: 'Create Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.EditIndustry',
								label: 'Edit Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.DeleteIndustry',
								label: 'Delete Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Invoices.Currency',
						label: 'Currency',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Currency.CreateCurrency',
								label: 'Create Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.EditCurrency',
								label: 'Edit Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.DeleteCurrency',
								label: 'Delete Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					}

				]
			},
			{
				key: 'Pages.Client',
				label: 'Clients',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Client.AddClient',
						label: 'Add Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.EditClient',
						label: 'Edit Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.DeleteClient',
						label: 'Delete Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Items',
				label: 'Items',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Items.AddItem',
						label: 'Add Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.EditItem',
						label: 'Edit Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.DeleteItem',
						label: 'Delete Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Notifications',
				label: 'Notifications',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Notifications.createNotification',
						label: 'Create Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.updateNotification',
						label: 'Update Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.deleteNotification',
						label: 'Delete Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.PaymentSchedule',
				label: 'Payment Schedule',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Reports',
				label: 'Reports',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},

			{
				key: 'Pages.Administration',
				label: 'Administration',
				data: 'Documents Folder',
				icon: 'pi pi-fw pi-inbox',
				children: [
					{
						key: 'Pages.Administration.User',
						label: 'Users',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.User.CreateUser',
								label: 'CreateUser',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.EditUser',
								label: 'Edit User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.DeleteUser',
								label: 'Delete User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},
					{
						key: 'Pages.Administration.Templates',
						label: 'Templates',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Templates.CreateTemplate',
								label: 'Create Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Templates.EditTemplate',
								label: 'Edit Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Settings',
						label: 'Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Settings.InvoiceNumberSequence',
								label: 'Invoice Number Sequence',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Role',
						label: 'Roles',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Role.CreateRole',
								label: 'Create Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.EditRole',
								label: 'Edit Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.DeleteRole',
								label: 'Delete Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					}


				]
			}
		]
	}

]

export const standardTree = [
	{
		key: "Pages",
		label: "Pages",
		data: "Pages",
		icon: "pi pi-fw pi-file",
		children: [
			{
				key: 'Pages.Dashboard',
				label: 'Dashboard',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Invoices',
				label: 'Invoices',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Invoices.CreateInvoice',
						label: 'Create Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.EditInvoice',
						label: 'Edit Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.DeleteInvoice',
						label: 'Delete Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.Sacgst',
						label: 'SAC GST',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.InvoicePayment',
						label: 'Invoice Payment',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.Industry',
						label: 'Industry',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Industry.CreateIndustry',
								label: 'Create Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.EditIndustry',
								label: 'Edit Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.DeleteIndustry',
								label: 'Delete Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Invoices.Currency',
						label: 'Currency',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Currency.CreateCurrency',
								label: 'Create Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.EditCurrency',
								label: 'Edit Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.DeleteCurrency',
								label: 'Delete Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					}

				]
			},
			{
				key: 'Pages.Client',
				label: 'Clients',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Client.AddClient',
						label: 'Add Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.EditClient',
						label: 'Edit Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.DeleteClient',
						label: 'Delete Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.ClietDocuments',
						label: 'Cliet Documents',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Items',
				label: 'Items',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Items.AddItem',
						label: 'Add Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.EditItem',
						label: 'Edit Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.DeleteItem',
						label: 'Delete Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Notifications',
				label: 'Notifications',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Notifications.createNotification',
						label: 'Create Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.updateNotification',
						label: 'Update Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.deleteNotification',
						label: 'Delete Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.PaymentSchedule',
				label: 'Payment Schedule',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Reports',
				label: 'Reports',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},

			{
				key: 'Pages.Administration',
				label: 'Administration',
				data: 'Documents Folder',
				icon: 'pi pi-fw pi-inbox',
				children: [
					{
						key: 'Pages.Administration.User',
						label: 'Users',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.User.CreateUser',
								label: 'CreateUser',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.EditUser',
								label: 'Edit User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.DeleteUser',
								label: 'Delete User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},
					{
						key: 'Pages.Administration.Templates',
						label: 'Templates',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Templates.CreateTemplate',
								label: 'Create Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Templates.EditTemplate',
								label: 'Edit Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Settings',
						label: 'Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Settings.InvoiceNumberSequence',
								label: 'Invoice Number Sequence',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Role',
						label: 'Roles',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Role.CreateRole',
								label: 'Create Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.EditRole',
								label: 'Edit Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.DeleteRole',
								label: 'Delete Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					}


				]
			}
		]
	}

]

export const professionalTree = [
	{
		key: "Pages",
		label: "Pages",
		data: "Pages",
		icon: "pi pi-fw pi-file",
		children: [
			{
				key: 'Pages.Dashboard',
				label: 'Dashboard',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Invoices',
				label: 'Invoices',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Invoices.CreateInvoice',
						label: 'Create Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.EditInvoice',
						label: 'Edit Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.DeleteInvoice',
						label: 'Delete Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.Sacgst',
						label: 'SAC GST',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.InvoicePayment',
						label: 'Invoice Payment',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.Industry',
						label: 'Industry',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Industry.CreateIndustry',
								label: 'Create Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.EditIndustry',
								label: 'Edit Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.DeleteIndustry',
								label: 'Delete Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Invoices.Currency',
						label: 'Currency',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Currency.CreateCurrency',
								label: 'Create Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.EditCurrency',
								label: 'Edit Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.DeleteCurrency',
								label: 'Delete Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					}

				]
			},
			{
				key: 'Pages.Client',
				label: 'Clients',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Client.AddClient',
						label: 'Add Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.EditClient',
						label: 'Edit Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.DeleteClient',
						label: 'Delete Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.ClientDocuments',
						label: 'Client Documents',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Items',
				label: 'Items',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Items.AddItem',
						label: 'Add Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.EditItem',
						label: 'Edit Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.DeleteItem',
						label: 'Delete Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Notifications',
				label: 'Notifications',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Notifications.createNotification',
						label: 'Create Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.updateNotification',
						label: 'Update Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.deleteNotification',
						label: 'Delete Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.PaymentSchedule',
				label: 'Payment Schedule',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.PaymentSchedule.CalenderView',
						label: 'Calender View',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.PaymentSchedule.PaymentTimelineAndForeCast',
						label: 'Payment Timeline And Forecast',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}

				]
			},
			{
				key: 'Pages.Reports',
				label: 'Reports',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},

			{
				key: 'Pages.Administration',
				label: 'Administration',
				data: 'Documents Folder',
				icon: 'pi pi-fw pi-inbox',
				children: [
					{
						key: 'Pages.Administration.User',
						label: 'Users',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.User.CreateUser',
								label: 'CreateUser',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.EditUser',
								label: 'Edit User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.DeleteUser',
								label: 'Delete User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},
					{
						key: 'Pages.Administration.Templates',
						label: 'Templates',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Templates.CreateTemplate',
								label: 'Create Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Templates.EditTemplate',
								label: 'Edit Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Settings',
						label: 'Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Settings.InvoiceNumberSequence',
								label: 'Invoice Number Sequence',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Role',
						label: 'Roles',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Role.CreateRole',
								label: 'Create Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.EditRole',
								label: 'Edit Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.DeleteRole',
								label: 'Delete Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					}


				]
			}
		]
	}

]

export const enterpriseTree = [
	{
		key: "Pages",
		label: "Pages",
		data: "Pages",
		icon: "pi pi-fw pi-file",
		children: [
			{
				key: 'Pages.Dashboard',
				label: 'Dashboard',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
			},
			{
				key: 'Pages.Invoices',
				label: 'Invoices',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Invoices.CreateInvoice',
						label: 'Create Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.EditInvoice',
						label: 'Edit Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.DeleteInvoice',
						label: 'Delete Invoice',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.Sacgst',
						label: 'SAC GST',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
					,
					{
						key: 'Pages.Invoices.InvoicePayment',
						label: 'Invoice Payment',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Invoices.Industry',
						label: 'Industry',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Industry.CreateIndustry',
								label: 'Create Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.EditIndustry',
								label: 'Edit Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Industry.DeleteIndustry',
								label: 'Delete Industry',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Invoices.Currency',
						label: 'Currency',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Invoices.Currency.CreateCurrency',
								label: 'Create Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.EditCurrency',
								label: 'Edit Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Invoices.Currency.DeleteCurrency',
								label: 'Delete Currency',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					}

				]
			},
			{
				key: 'Pages.Client',
				label: 'Clients',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Client.AddClient',
						label: 'Add Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.EditClient',
						label: 'Edit Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.DeleteClient',
						label: 'Delete Client',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Client.ClientDocuments',
						label: 'Client Documents',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Items',
				label: 'Items',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Items.AddItem',
						label: 'Add Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.EditItem',
						label: 'Edit Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Items.DeleteItem',
						label: 'Delete Item',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.Notifications',
				label: 'Notifications',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Notifications.createNotification',
						label: 'Create Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.updateNotification',
						label: 'Update Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.Notifications.deleteNotification',
						label: 'Delete Notification',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}
				]
			},
			{
				key: 'Pages.PaymentSchedule',
				label: 'Payment Schedule',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.PaymentSchedule.CalenderView',
						label: 'Calender View',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
					{
						key: 'Pages.PaymentSchedule.PaymentTimelineAndForeCast',
						label: 'Payment Timeline And Forecast',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					}

				]
			},
			{
				key: 'Pages.Reports',
				label: 'Reports',
				data: 'Home Folder',
				icon: 'pi pi-fw pi-home',
				children: [
					{
						key: 'Pages.Reports.GenerateReport',
						label: 'Generate Report',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
					},
				]
			},

			{
				key: 'Pages.Administration',
				label: 'Administration',
				data: 'Documents Folder',
				icon: 'pi pi-fw pi-inbox',
				children: [
					{
						key: 'Pages.Administration.User',
						label: 'Users',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.User.CreateUser',
								label: 'CreateUser',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.EditUser',
								label: 'Edit User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.User.DeleteUser',
								label: 'Delete User',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					},
					{
						key: 'Pages.Administration.Templates',
						label: 'Templates',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Templates.CreateTemplate',
								label: 'Create Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Templates.EditTemplate',
								label: 'Edit Template',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Settings',
						label: 'Settings',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Settings.InvoiceNumberSequence',
								label: 'Invoice Number Sequence',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							}
						]
					},
					{
						key: 'Pages.Administration.Role',
						label: 'Roles',
						data: 'Home Folder',
						icon: 'pi pi-fw pi-home',
						children: [
							{
								key: 'Pages.Administration.Role.CreateRole',
								label: 'Create Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.EditRole',
								label: 'Edit Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
							{
								key: 'Pages.Administration.Role.DeleteRole',
								label: 'Delete Role',
								data: 'Home Folder',
								icon: 'pi pi-fw pi-home',
							},
						]
					}


				]
			}
		]
	}

]